import { observable, decorate, action } from "mobx";
import {
  makeSpotifyAPIRequest,
  getAlbumArtURLFromImages,
} from "../api_utilities/spotify";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";

class SnobifyStore {
  currentlyPlayingTrack = { tags: [], rating: "" };
  isCurrentlyPlaying = false;
  tagsForUser = [];
  ratedOrTaggedTracks = {};

  rateCurrentlyPlayingTrack = (rating) => {
    this.currentlyPlayingTrack.rating = rating;
    this.rateTrack(this.currentlyPlayingTrack.trackID, rating);
  };

  setCurrentlyPlayingTrackTags = (newTags) => {
    this.currentlyPlayingTrack.tags = newTags;
    this.tagTrack(this.currentlyPlayingTrack.trackID, newTags);
  };

  rateTrack = (trackID, rating) => {
    if (!(trackID in this.ratedOrTaggedTracks)) {
      this.ratedOrTaggedTracks[trackID] = { rating: rating, tags: null };

      return;
    }

    this.ratedOrTaggedTracks[trackID]["rating"] = rating;
  };

  tagTrack = (trackID, tags) => {
    if (!(trackID in this.ratedOrTaggedTracks)) {
      this.ratedOrTaggedTracks[trackID] = { rating: null, tags: tags };

      return;
    }

    this.ratedOrTaggedTracks[trackID]["tags"] = tags;
  };

  updateCurrentlyPlayingTrack = () => {
    const url = new URL(
      "https://api.spotify.com/v1/me/player/currently-playing"
    );

    makeSpotifyAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: (data) => {
        const item = data.item;

        if (item.id != null) {
          const album = item.album;
          const artists = item.artists;

          this.isCurrentlyPlaying = data.is_playing;
          this.currentlyPlayingTrack.trackProgress = data["progress_ms"];

          if (item.id !== this.currentlyPlayingTrack.trackID) {
            this.currentlyPlayingTrack.albumName = album.name;
            this.currentlyPlayingTrack.albumID = album.id;
            this.currentlyPlayingTrack.albumTotalTracks = album.total_tracks;
            this.currentlyPlayingTrack.albumArtURL = getAlbumArtURLFromImages(
              album.images
            );
            this.currentlyPlayingTrack.artistNames = artists
              .map((artist) => artist.name)
              .join(", ");
            this.currentlyPlayingTrack.releaseYear = new Date(
              album.release_date
            ).getFullYear();
            this.currentlyPlayingTrack.trackName = item.name;
            this.currentlyPlayingTrack.trackLength = item["duration_ms"];
            this.currentlyPlayingTrack.trackNumber = item["track_number"];

            const url = new URL(backendBaseURL + "/song/get_songs_and_tags");
            makeBackendAPIRequest({
              url: url,
              method: "POST",
              body: {
                tracks: JSON.stringify([
                  {
                    id_spotify: item.id,
                    song_name: item.name,
                    duration_ms: item["duration_ms"],
                    track_number: item["track_number"],
                    album: {
                      id_spotify: album.id,
                      name: album.name,
                      artists: album.artists
                        .map((artist) => artist.name)
                        .join(", "),
                      release_year: new Date(album.release_date).getFullYear(),
                      total_tracks: album.total_tracks,
                    },
                  },
                ]),
              },
              onSuccessCallback: (data) => {
                this.currentlyPlayingTrack.trackID = item.id;
                this.tagsForUser = data.tags_for_user;
                const songs_ang_tags = data.songs_and_tags;
                if (songs_ang_tags.length > 0) {
                  const song = songs_ang_tags[0];
                  this.currentlyPlayingTrack.rating = song.deliberately_unrated
                    ? "-"
                    : song.rating;
                  this.currentlyPlayingTrack.tags = song.tags;
                } else {
                  this.currentlyPlayingTrack.rating = "";
                  this.currentlyPlayingTrack.tags = [];
                }
              },
              onFailureCallback: () => {
                this.currentlyPlayingTrack.trackID = item.id;
                this.currentlyPlayingTrack.rating = "";
                this.currentlyPlayingTrack.tags = [];
              },
            });
          }
        } else {
          this.currentlyPlayingTrack = { tags: [], rating: "" };
          this.isCurrentlyPlaying = false;
        }
      },
      onNoContentCallback: () => {
        this.currentlyPlayingTrack = { tags: [], rating: "" };
        this.isCurrentlyPlaying = false;
      },
    });
  };
}

export default decorate(SnobifyStore, {
  currentlyPlayingTrack: observable,
  isCurrentlyPlaying: observable,
  tagsForUser: observable,
  ratedOrTaggedTracks: observable,
  rateCurrentlyPlayingTrack: action,
  setCurrentlyPlayingTrackTags: action,
  updateCurrentlyPlayingTrack: action,
  rateTrack: action,
  tagTrack: action,
});
